import React, { useRef, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import {  countryCallingCodes, Validation} from "../../helper/function";

import axiosInstance from '../../helper/AxiosInstance'

function RequestForm() {
  const [countrys, setCountrys] = useState(countryCallingCodes)
  const navigate = useNavigate();
  const closeModalRef = useRef(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [industries, setIndustries] = useState([]);

  const [reqDemoData, setReqDemoData] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    industry: "",
    countryCode: '+91',
    searchCountry: ''
  });

  const [validateReqDemoData, setValidateReqDemoData] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    industry: "",
  });

  // Fetch Industries
  const fetchIndustries = async () => {
    setIsLoading(true);
    try {
      const res = await axiosInstance.get('/public/industries');
      setIsLoading(false);
      if (res.status === "success") {
        setIndustries(res.data);

      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  }



  // handle request demo form data change
  const handleReqDemoDataChange = (e) => {
    Validation(e)
    const name = e.target.name;
    const value = e.target.value;

    if (name === "email") {
      e.target.value = e.target.value.toLowerCase();
    }

    setValidateReqDemoData((prev) => ({
      ...prev,
      [name]: "",
    }));

    setReqDemoData((prev) => ({
      ...prev,
      [name]: name === "email" ? value?.toLowerCase() : value,
    }));
  };

  function isValidFirstNameClient(name) {
    const validNamePattern = /^[A-Za-z ]*$/;
    return name === "" || validNamePattern.test(name);
  }

  function isValidEmailClient(email) {
    const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;

    return emailPattern.test(email);
  }

  function isValidMobileNumberClient(number) {
    const mobileNumberPattern = /^(\+\d{1,3})?[6-9]\d{9}$/;

    return mobileNumberPattern.test(number);
  }

  // POST request demo data
  const submitReqDemoData = async (e) => {
    e.preventDefault();

    if (
      !reqDemoData?.firstName ||
      !isValidFirstNameClient(reqDemoData?.firstName) ||
      !isValidFirstNameClient(reqDemoData?.lastName) ||
      !isValidEmailClient(reqDemoData?.email) ||
      !isValidMobileNumberClient(reqDemoData?.mobile) ||
      !reqDemoData?.industry
    ) {
      setValidateReqDemoData({
        firstName: !reqDemoData?.firstName ? "First name is required" : !isValidFirstNameClient(reqDemoData?.firstName) ? "Invalid first name" : null,

        lastName: !isValidFirstNameClient(reqDemoData?.lastName) ? "Invalid last name" : null,

        mobile: !reqDemoData?.mobile ? "Mobile number is required" : !isValidMobileNumberClient(reqDemoData?.mobile) ? "Invalid mobile number" : null,
        email: !reqDemoData?.email ? "Email is required" : !isValidEmailClient(reqDemoData?.email) ? "Invalid email" : null,
        industry: !reqDemoData?.industry ? "Industry is required" : null,
      });

      return;
    }
    setIsSubmitting(true);
    // console.log(reqDemoData);

    try {
      // const res = await axios.post("https://phplaravel-979432-4660383.cloudwaysapps.com/api/taskflier/enquiry", reqDemoData);

      // const res = await axios.post(`${getProdDevURL().REACT_APP_API_URL}/public/req/demo`, reqDemoData);

      const res = await axiosInstance.post(`/public/req/demo/enquiry`, reqDemoData);

      console.log("req demo res: ", res);
      if (res.status === "success") {
        setReqDemoData({
          firstName: "",
          lastName: "",
          mobile: "",
          email: "",
          industry: "",
        });
        toast.success(res.message);

        navigate("/enquiry-raised");
        closeModalRef.current.click();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // useEffect(() => {
  //   window.AOS.init({});
  //   window.scrollTo(0, 0);
  // });

  useEffect(() => {
    fetchIndustries();
  }, [])
  useEffect(() => {
    setCountrys(countryCallingCodes.filter(cty => cty.name.toLowerCase().includes(reqDemoData.searchCountry.toLowerCase()) || cty.code.toLowerCase().includes(reqDemoData.searchCountry.toLowerCase())))
}, [reqDemoData.searchCountry])
  return (
    <div>
    
       
        <div class="hero-banner-two bgblue pt-50">
          <div class="container">
            <div class="row align-items-start justify-content-between">
              <div class="col-lg-6 order-lg-last">
                <div class="req-bg">
                  <p className="text-center text-black fs-16 fw-500 mb-3">Fill out the demo request form and let’s get started today!</p>

                  <form onSubmit={submitReqDemoData} className="submitrequest">
                    <div className="messages" />
                    <div className="row controls">
                      <div className="col-6">
                        <div className="input-group-meta form-group mb-15">
                          <label>First Name*</label>
                          <input
                            data-type="name"
                            type="text"
                            placeholder="Your First Name"
                            name="firstName"
                            id="lastname"
                            data-error="Name is required."
                            onChange={handleReqDemoDataChange}
                            value={reqDemoData?.firstName}
                          />

                          {/* <div className="help-block with-errors" /> */}
                          <p className="text-danger small text-center">{validateReqDemoData?.firstName}</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="input-group-meta form-group mb-15">
                          <label>Last Name</label>
                          <input
                            data-type="name"
                            type="text"
                            placeholder="Your Last Name"
                            name="lastName"
                            id="lastname"
                            data-error="Name is required."
                            onChange={handleReqDemoDataChange}
                            value={reqDemoData?.lastName}
                          />
                          <p className="text-danger small text-center">{validateReqDemoData?.lastName}</p>
                          {/* <div className="help-block with-errors" /> */}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="input-group-meta  form-group mb-15">
                          <label>Email*</label>
                          <input type="text" data-type="email" placeholder="Email Address" name="email" id="email" data-error="Valid email is required." onChange={handleReqDemoDataChange} value={reqDemoData?.email} />
                          <p className="text-danger small text-center">{validateReqDemoData?.email}</p>
                          {/* <div className="help-block with-errors" /> */}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="input-group-meta form-group mb-1"><label>Phone <span class="text-danger">*</span></label>
                        

                          
                          <div className="input-group contactvalid">

   

<button class="input-group-text dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">{reqDemoData?.countryCode || 'Code'}</button>
                            
<ul class="dropdown-menu country-filter">

 <li style={{ cursor: "pointer" }} className="search-menu" >

<span class="dropdown-item"> <i class="bi bi-search icon-search"></i> 
<input data-type="name"  className="form-control form-control-sm search-bar" name="searchCountry" placeholder="Search Country" value={reqDemoData.searchCountry} onInput={handleReqDemoDataChange} /></span>
</li>
{(countrys || []).map((cty) => { return (<li onClick={() => { setReqDemoData((prev) => ({ ...prev, searchCountry: '', countryCode: cty.code, country: cty.name })) }}><span class="dropdown-item">{cty.name}</span></li>) })}
                            
 </ul>

 <input data-type="mobile" class="form-control" name="mobile" id="monile" type="text" placeholder="enter mobile no" value={reqDemoData.mobile} onInput={handleReqDemoDataChange} required />
                                                          

</div>


                        </div>
                      </div>
                      <div className="col-12">
                        <div className="input-group-meta form-group mb-2">
                          <label>Apply For*</label>
                          <select name="industry" data-error="Valid Category is required." id="subject" onChange={handleReqDemoDataChange}>
                            <option selected={reqDemoData?.industry === "" ? true : false} value="">
                              -- Select Industries --
                            </option>
                            {
                              isLoading ?
                                <option value={""}>Loading ...</option>
                                :
                                industries.map((industry) => <option key={industry._id} value={industry._id}>{industry.name}</option>)
                            }
                            {/* <option value="Enterprise">Enterprise</option>
                            <option value="Construction">Construction</option>
                            <option value="Software Development">Software Development </option>
                            <option value="Education">Education</option>
                            <option value="Marketing">Marketing </option>
                            <option value="Startup">Startup</option>
                            <option value="Testing">Testing</option>
                            <option value="Real Estate">Real Estate</option>
                            <option value="Consulting Industries">Consulting Industries</option>
                            <option value="Law">Law</option> */}
                          </select>
                          <p className="text-danger small text-center">{validateReqDemoData?.industry}</p>
                          {/* <div className="help-block with-errors" /> */}
                        </div>
                      </div>

                      <p className="fs-12 privacy">
                        By submitting this form, you are consenting to the handling of your personal information in accordance with our{" "}
                        <Link to="/Privacy" className="text-primary">
                          Privacy Policy
                        </Link>
                        .
                      </p>
                      <div className="col-12">
                        {!isSubmitting ? (
                          <button type="submit" className="theme-btn-seven w-100">
                            Send Message
                          </button>
                        ) : (
                          <button className="theme-btn-seven w-100" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                            <span role="status">Loading...</span>
                          </button>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="col-xl-5 col-lg-6 order-lg-first">
                <div class="hero-text-wrapper  md-mt-50">
                  <h1 className="text-white font-rubik  title-request">Get Started With Demo Request</h1>
                  <p class=" text-white fs-14 mt-3">
                    Looking to streamline your project management processes? We’re here to help! Request a personalized demo today to see how our platform can empower your team and deliver results
                    efficiently.
                  </p>

                  <ul className="request-demo-list mb-4">
                    <li>
                      {" "}
                      <i class="bi bi-check-lg "></i> Organize, assign, and track tasks in real-time.
                    </li>
                    <li>
                      {" "}
                      <i class="bi bi-check-lg "></i> Tailor project pipelines to fit your team’s unique processes.
                    </li>
                    <li>
                      {" "}
                      <i class="bi bi-check-lg "></i> Real-Time Reporting & Analytics
                    </li>
                    <li>
                      {" "}
                      <i class="bi bi-check-lg "></i> Ensure timely and budget-compliant completion.
                    </li>
                  </ul>

                  <div className="clearfix"></div>

                  <p class=" text-white fs-20 mt-6">If any questions feel free to Contact Us</p>
                  <h4 className="text-white fs-20">sales@taskflier.com</h4>
                  <div className="row">
                    <div class="col-lg-2 col-4 mt-30 requestdemo">
                      <div className="certifys request">
                        <img src="/images\certificate/badge-04.png" alt="" />
                      </div>
                    </div>

                    <div class="col-lg-2 col-4 mt-30 requestdemo">
                      <div className="certifys request">
                        <Link target="_blank" to="https://www.topdevelopers.co/companies/software-development">
                          <img
                            src="https://www.topdevelopers.co/assets/badges/app-2024/Software-Development/badge-top-software-developers-2024.png"
                            alt="Top Software Developer"
                            title="Top Software Developer"
                          />
                        </Link>
                      </div>
                    </div>

                    <div class="col-lg-2 col-4 mt-30 requestdemo">
                      <div className="certifys request">
                        <img src="/images\certificate/badge-08.png" alt="" />
                      </div>
                    </div>

                    <div class="col-lg-2 col-4 mt-30 requestdemo">
                      <div className="certifys request">
                        <img src="/images\certificate/badge-07.png" alt="" />
                      </div>
                    </div>

                    <div class="col-lg-2 col-4 mt-30 requestdemo">
                      <div className="certifys request">
                        <Link target="_blank" to="https://www.goodfirms.co/project-management-software/">
                          <img src="https://assets.goodfirms.co/badges/color-badge/project-management.svg" title="Top Project Management Software" alt="Top Project Management Software" />
                        </Link>
                      </div>
                    </div>

                    <div class="col-lg-2 col-4 mt-30 requestdemo">
                      <div className="certifys request">
                        <Link to="https://www.softwaresuggest.com/taskflier" target="_blank">
                          <img src="https://www.softwaresuggest.com/award_logo/highly-recommended-2024.png" alt="" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="hero-banner-five bg-white">
          <div class="partner-slider-two mt-20 md-mt-80">
            <div class="container">
              <h3 class="text-center maintitle mb-3">
                The Top Names <span>Trust It</span>{" "}
              </h3>
              <div class="partnerSliderTwo d-flex">
                <div class="item col-md-2">
                  <div class="img-meta d-flex align-items-center justify-content-center">
                    <img src="/images/client/NV.png" alt="" />
                  </div>
                </div>
                <div class="item col-md-2">
                  <div class="img-meta d-flex align-items-center justify-content-center">
                    <img src="/images/client/SSR.png" alt="" />
                  </div>
                </div>
                <div class="item col-md-2">
                  <div class="img-meta d-flex align-items-center justify-content-center">
                    <img src="/images/client/White.png" alt="" />
                  </div>
                </div>
                <div class="item col-md-2">
                  <div class="img-meta d-flex align-items-center justify-content-center">
                    <img src="/images/client/MNB.png" alt="" />
                  </div>
                </div>
                <div class="item col-md-2">
                  <div class="img-meta d-flex align-items-center justify-content-center">
                    <img src="/images/client/Kashi.png" alt="" />
                  </div>
                </div>
                <div class="item col-md-2">
                  <div class="img-meta d-flex align-items-center justify-content-center">
                    <img src="/images/client/Mesma.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="fancy-text-block-twenty bg-white pb-0 pt-100" style={{ padding: "100px 0 0 0 " }}>
          <div class="container">
            <div class="row">
              <div class="col-lg-5 aos-init aos-animate" data-aos="fade-right" data-aos-duration="1200">
                <div class="client-info font-rubik">
                  Over <span>150,000+ client</span>
                </div>
                <div class="maintitle">
                  <h2>
                    <span>Excellent work</span>
                    <br /> &amp; environments combine individuals with testing issues.
                  </h2>
                </div>
              </div>
              <div class="col-lg-6 ">
                <ul class="nav nav-tabs md-mt-50">
                  <li class="nav-item" role="presentation">
                    <a class="nav-link  active" data-bs-toggle="tab" data-bs-target="#our-story" href="#our-story">
                      Vision
                    </a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a class="nav-link " data-bs-toggle="tab" data-bs-target="#our-mission" href="#our-mission">
                      Goal{" "}
                    </a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a class="nav-link " data-bs-toggle="tab" data-bs-target="#our-vision" href="#our-vision">
                      Objective
                    </a>
                  </li>
                </ul>

                <div class="tab-content mt-20">
                  <div class="tab-pane fade active show" id="our-story">
                    <p class="mainp">
                      Taskflier aims to simplify and enhance the way people manage their tasks and projects. We envision a platform that not only makes task management easier but also helps users
                      achieve their goals more efficiently.{" "}
                    </p>
                    <p class="mainp pt-0">
                      By focusing on user-friendly design and powerful features, we want Taskflier to be the go-to solution for anyone looking to improve their productivity and workflow. Taskflier
                      wants to change how people manage their tasks and projects. We see a future where our platform helps users easily keep track of what they need to do, stay organized, and work
                      together with others smoothly.
                    </p>
                  </div>
                  <div class="tab-pane fade" id="our-mission">
                    <p class="mainp">
                      Our goal is to create a transformative task management experience that not only enhances your productivity but also prioritizes your privacy at every turn. We aim to deliver a
                      platform that is both powerful and intuitive, offering sophisticated tools to streamline your workflow while maintaining stringent security protocols.{" "}
                    </p>
                    <p class="mainp pt-0">
                      By blending cutting-edge technology with a deep commitment to data protection, we strive to empower users to work smarter and more securely. Our mission is to provide a solution
                      where you can confidently manage your tasks and projects, knowing that your data is safe, your workflow is optimized, and your ambitions are within reach.
                    </p>
                  </div>
                  <div class="tab-pane " id="our-vision">
                    <p class="mainp">
                      The objective of Taskflier is to help users manage and track their tasks effectively. It allows users to create and organize tasks into projects or categories, which helps in
                      managing various responsibilities. Users can assign priorities and set deadlines, aiding in effective time management and focus on high-priority tasks.{" "}
                    </p>
                    <p class="mainp pt-0">The platform sends reminders and notifications to keep users on track and reduce the risk of forgetting important deadlines.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button className="scroll-top" style={{ display: "none" }}>
          <i className="fa fa-angle-up" aria-hidden="true" />
        </button>

        <div className="modal fade modal-contact-popup-one" id="contactModal" tabIndex={-1} role="dialog" aria-labelledby="contactModalTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <main className="main-body modal-content clearfix">
              <div className="right-side"></div>
            </main>
          </div>
        </div>

    </div>
  );
}

export default RequestForm;
